import React from 'react';
import { Link } from 'react-router-dom';
import Suggestions from './Suggestion';
import Register from './Register';
import base from '../main.jpg';
import {NAME,LASTNAME} from '../settings';
// import swal from 'sweetalert';

var md5 = require('md5');
let bar;

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            login: this.props.user.login,
            results: {},
            user: "",
            pass: ""
        }

        this.handleInputUser = this.handleInputUser.bind(this);
        // this.password = this.password.bind(this);
        this.login = this.login.bind(this);
        this.salir = this.salir.bind(this);

    }
    salir(event) {
        this.props.removeFromUser();
        this.setState({ user: "", pass: "" });
        event.preventDefault();
    }

    login(ui, e) {
        e.preventDefault();
        // console.log(ui,JSON.parse(localStorage.getItem('value')));



        if (!ui) {
            if (localStorage.getItem('value')) {
                this.props.login(JSON.parse(localStorage.getItem('value')), false);
            } else if (localStorage.getItem('token')) {
                console.log(localStorage.getItem('token'));
                this.props.login({ token: JSON.parse(localStorage.getItem('token')) }, false, true);
            }

            // this.props.login({ pass: md5(this.state.pass), user: this.state.user }, false);
        } else {
            this.props.login({ pass: md5(this.state.pass), user: this.state.user }, true);
            // this.setState({ pass: "" });
        }
    }
    handleInputUser(objuser) {
        // console.log(objuser.target.name)
        this.setState({ [objuser.target.name]: objuser.target.value });
    }
    // password(objpass) {
    //     // console.log(objpass.target.value)
    //     this.setState({ pass: objpass.target.value });
    // }

    getInfo = () => {
        fetch(this.props.api + '/list/model/search/id/' + this.state.query, { cache: "no-cache" }).then(results => {
            return results.json();
        }).then(select => {
            this.setState({
                results: select
            })
            // console.log(select)
        }).catch(function (error) {
            // console.log('Hubo un problema con la petición Fetch:' + error.message);
            // this.setState({ loading: false })
        });

    }

    del = () => {
        setTimeout(() => {
            this.setState({
                results: {}
            })
        }, 20)

    }
    handleInputChange = (i, e) => {
        // console.log(i.target.value);
        let query = i.target.value;
        // console.log(e.value);
        this.setState({
            query: i.target.value
        }, () => {
            if (query && query.length > 2) {
                this.getInfo()
            } else if (!query) {
                this.setState({
                    results: {}
                })
            } else {
                this.setState({
                    results: {}
                })
            }
        })
    }

    static getDerivedStateFromProps(props, current_state) {



        if (current_state.login !== props.login) {
            if (props.user)
                return { login: props.user.login }

        }
        return null;

    }
    render() {
        if (!this.state.login) {
            bar = <div className="pt-1 mr-1  w-100" >
                <button className="btn btn-sm btn-success m-1 text-truncate d-inline-block float-right" type="button" data-toggle="modal" data-target="#login">{this.props.language().login}</button>
                {/* <button className="btn btn-sm btn-outline-success m-1 text-truncate d-inline-block" type="button" data-toggle="modal" data-target="#register">{this.props.language().register}</button> */}

            </div>
        }
        else if (this.props.user.userdata.auto) {
            bar = <div className="pt-1 mr-1  w-100" >
                <Link to='/mybets' className="btn btn-sm btn-success m-1 text-truncate d-inline-block float-right" >{this.props.language().myBets}</Link>
            </div>
        }
        else {

            bar = <div className="pt-1 mr-1 d-inline-flex w-100 justify-content-around">
                <div className="btn btn-success m-1 text-truncate btn-sm d-none d-inline-block" id="refresh" onClick={this.login.bind(this, false)} data-toggle="tooltip" data-placement="bottom" title="Click to Sync" >
                    <i className="fas fa-dollar-sign"></i>  {this.props.user.userdata ? this.props.user.userdata.balance.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : ""}
                    <i style={{ marginLeft: 15 }} className="fas fa-sync"></i>


                </div>
                <div className="dropdown ">
                    <button className="btn btn-outline-light m-1 text-truncate btn-sm d-none d-inline-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="far fa-user"></i> {this.props.user.userdata ? this.props.user.userdata.username : ""}</button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                        <div className="dropdown-item" data-toggle="modal" data-target="#user">{this.props.language().profile}</div>
                        <Link to='/mybets' className="dropdown-item" >{this.props.language().myBets}</Link>
                        {/* <div className="dropdown-item" >this.props.language()</div> */}
                        <div className="dropdown-divider"></div>
                        <div onClick={this.salir} className="dropdown-item" >{this.props.language().logout}</div>
                    </div>
                    {/* <Link to='/mybets' className="btn btn-outline-success m-1 text-truncate btn-sm d-none d-inline-block" ><i className="fas fa-bars"></i> {this.props.language().bets}</Link> */}
                </div>
            </div>
        }
        let auto = this.props.user.userdata ? (this.props.user.userdata.auto ? true : false) : false;

        return (<div>
            {/* mobile logo */}
            {!auto && <nav className="navbar  d-flex d-md-none" style={{ justifyContent: 'left' }}>
                <div className="mt-1 d-flex ml-1 justify-content-between" id="sidebarCollapseMobil" >
                    <div className="btn">
                        <i className="fas fa-align-justify"></i>
                    </div>
                </div>
                <Link to="/" className='pl-2' style={{ fontSize: 30 }}>
                    <img className="img-logo" alt="" src={this.props.logo} width='60px' />
                    {NAME}<span style={{ color: "white" }}>{LASTNAME}</span></Link>
            </nav>}
            {/* mobile bar */}
            <nav className="d-xs-block d-md-none navbar">
                <div className="btn">
                    <i className="fas fa-align-justify"></i>
                </div>
                <div className="px-3 py-0" style={{ width: '100%' }}>

                    <div className=" input-group mb-2 mr-sm-2 " style={{ width: '100%' }}>
                        <div className="input-group-prepend ">
                            <div className="input-group-text"><i className="fas fa-search"></i></div>
                        </div>
                        <input type="text" className="form-control form-control-sm text-truncate" id="inlineMovil" placeholder={this.props.language().search}
                            value={this.state.query}
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputChange}
                            onBlur={this.del}
                        />
                        <Suggestions results={this.state.results} />

                    </div>
                </div>
            </nav>
            {/* normal bar */}
            <nav className="navbar navbar-expand-lg  p-0 justify-content-around">
                <div className="d-none d-md-flex justify-content-between pt-2" >
                    <div className="mt-1 ml-1 justify-content-between d-none d-md-inline" id="sidebarCollapse" >
                        <div className="btn">
                            <i className="fas fa-align-justify"></i>
                        </div>

                    </div>
                </div>
                <div className="d-flex justify-content-between pt-2" style={{ width: '90%' }}>

                    <div className="pt-2 px-2 d-none d-md-block" style={{ width: '100%' }}>
                        <div className=" input-group mb-2 mr-sm-2 " style={{ width: '100%' }}>
                            <div className="input-group-prepend ">
                                <div className="input-group-text"><i className="fas fa-search"></i></div>
                            </div>
                            <input type="text" className="form-control form-control-sm text-truncate" id="inlineWeb" placeholder={this.props.language().search}
                                value={this.state.query}
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputChange}
                                onBlur={this.del}
                            />
                            <Suggestions results={this.state.results} />

                        </div>
                    </div>

                    {bar}

                </div>
            </nav>


            {/* modal login */}
            <div className="modal fade " id="login" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" style={{ maxWidth: 1444, marginTop: 0, marginBottom: 0, height: "100%" }} role="document">
                    <div className="modal-content" style={{ height: '100%' }}>
                        <button type="button" id="closeModalLogin" className="close btn m-3 text-right" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" className="text-info">  <i className="far fa-window-close"></i></span>
                        </button>
                        <div className="modal-body p-0 m-0" style={{ height: "100%" }}>

                            <div className="row" style={{ height: "100%" }}>
                                <div className="col-md-4 d-none d-md-block" style={{ height: "100%" }}>
                                    <div style={{ height: "100%" }}>
                                        <div className="imagelogin" style={{ backgroundImage: `url(${base})` }}></div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-8">

                                    <div className="p-4 row">

                                        <div className="col-sm-3 d-none d-lg-block"></div>
                                        <div className="col-sm-12 col-lg-6">
                                            <div className="sidebar-header d-flex justify-content-center pb-3">
                                                <Link to="/" style={{ fontSize: 30, textAlign: 'center' }}>
                                                    <img className="img-logo" alt="" src={this.props.logo} width='100px' />
                                                    {NAME}<span style={{ color: "white" }}>{LASTNAME}</span></Link>
                                            </div>
                                            <h3>{this.props.language().login}</h3>
                                            <form onSubmit={this.login.bind(this, true)} style={{ textAlign: 'center' }}>
                                                <div className="form-group row">

                                                    <div className="col-sm-12">
                                                        <input type="text" className="form-control" id="username" name="user" placeholder={this.props.language().user} value={this.state.user} onChange={this.handleInputUser} />
                                                    </div>
                                                </div>
                                                <div className="form-group row">

                                                    <div className="col-sm-12">
                                                        <input type="password" className="form-control" id="password" name="pass" placeholder={this.props.language().pass} value={this.state.pass} onChange={this.handleInputUser} />
                                                        <small id="emailHelp" className="form-text text-muted float-right">
                                                            <Link to=''>{this.props.language().forgetPass}</Link>
                                                        </small>

                                                    </div>
                                                </div>


                                                <div className="form-group row">
                                                    <div className="col-sm-12 justify-content-between">
                                                        <button type="submit" id="loginbtn" ref="loginbtn" className="btn btn-success m-1 ">{this.props.language().login}</button>
                                                        <button type="submit" data-dismiss="modal" data-toggle="modal" data-target="#register" className="m-1 btn btn-outline-success ">{this.props.language().register}</button>
                                                    </div>

                                                </div>
                                                <div id="lds" className="lds-facebook d-none"><div></div><div></div><div></div></div>
                                            </form>
                                        </div>
                                        <div className="col-sm-3 d-none d-lg-block"></div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Register language={this.props.language} />

            {/* User Modal */}
            <div className="modal fade " id="user" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content" style={{ height: '100%' }}>

                        <div className="modal-body p-4 m-0" style={{ height: "100%" }}>
                            <button type="button" className="close btn m-3 text-right" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" className="text-info">  <i className="far fa-window-close"></i></span>
                            </button>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{this.props.language().profile}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">{this.props.language().security}</a>
                                </li>
                                <li className="nav-item d-none">
                                    <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">{this.props.language().verify}</a>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className='row p-3' >
                                        <div className='col-sm-6'>
                                            <div><small>{this.props.language().fullname}</small></div>
                                            <span className="odds">{this.props.user.userdata ? this.props.user.userdata.fullname : ""}</span>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div><small>{this.props.language().username}</small></div>
                                            <span className="odds">{this.props.user.userdata ? this.props.user.userdata.username : ""}</span>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div><small>{this.props.language().email}</small></div>
                                            <span className="odds">{this.props.user.userdata ? this.props.user.userdata.email : ""}</span>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div><small>{this.props.language().birthday}</small></div>
                                            <span className="odds">Dic 31, 1990</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    {/* <div className='row p-3'> */}
                                    <form className='p-5'>

                                        <div className="form-group">
                                            <label htmlFor="passAct">{this.props.language().currentpass}</label>
                                            <input type="password" className="form-control" id="passAct" placeholder="" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="passNew">{this.props.language().newpass}</label>
                                            <input type="password" className="form-control" id="passNew" placeholder="" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="passConfirm">{this.props.language().repeatpass}</label>
                                            <input type="password" className="form-control" id="passConfirm" placeholder="" />
                                        </div>

                                        <button type="submit" className="btn btn-success">{this.props.language().save}</button>
                                    </form>

                                </div>
                                <div className="tab-pane fade d-none" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                    <small className='row p-3'>
                                        Te pedimos que, para mayor seguridad, cargues tus documentos a revisión. Esto nos facilita el identificarte en caso de que pierdas el acceso a tu cuenta. También nos ayuda a asegurarnos de que recibas sus regalos y recompensas físicas a tu dirección correcta.
                                        <br />
                                        <br />
                                        Para obtener una prueba de identificación, envíanos una foto de un documento de identificación, licencia de conducir o pasaporte. Para obtener una prueba de domicilio, envíanos una foto de una factura de servicios públicos fechada dentro de los últimos tres meses y mostrando claramente tu nombre (en .jpg, .png y .gif). Verifica cuidadosamente los requerimientos antes de enviar tus documentos.

                                    </small>
                                    <div className="d-inline justify-content-between w-100">
                                        <button type="submit" className="btn btn-secondary">Seleccionar prueba de identificación</button>

                                        <button type="submit" className="btn btn-secondary">Seleccionar prueba de direccion</button>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>)
    }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar.js